// De-emphasis for schedule rows whose visit is completed (time passed AND a
// recording exists). The row used to carry `opacity: 0.55` + a grayscale
// filter on the <tr> itself, which dragged the select checkbox down with it:
// a child can never be more opaque than its parent, and Chakra's unchecked
// checkbox border (gray.200) was the very colour of the dimmed row's
// background (then #e5e7eb), so the box vanished. The dimming therefore lives on
// the data cells, and the select cell (marked `data-select-cell`) opts out.

export const DIMMED_CELL_OPACITY = 0.55;
export const DIMMED_CELL_FILTER = "grayscale(0.35)";

/** No-shows are never dimmed: their slate row background is its own signal
 *  and their checkbox is disabled anyway. */
export function isRowDimmed({ isCompleted, isNoShow }) {
  return Boolean(isCompleted) && !isNoShow;
}

/** Spread into the row's `sx`. Dims every cell except the select cell. */
export function dimmedRowSx(dimmed) {
  if (!dimmed) return {};
  return {
    "& > td": { opacity: DIMMED_CELL_OPACITY, filter: DIMMED_CELL_FILTER },
    "& > td[data-select-cell]": { opacity: 1, filter: "none" },
  };
}

/** `sx` for the row's select <Checkbox>. On a dimmed row the unchecked box
 *  gets a white fill and a mid-grey border so it reads as a live control against
 *  the grey band; the checked (blue) and disabled states keep Chakra's look. */
export function selectCheckboxSx(dimmed) {
  if (!dimmed) return undefined;
  return {
    "& .chakra-checkbox__control:not([data-checked])": {
      bg: "white",
      borderColor: "gray.500",
    },
  };
}
